
import { defineComponent, PropType, ref } from 'vue'
import ButtonDefault from '@/components/ui/ButtonDefault.vue'
import Sucess from '@/components/icons/Sucess.vue'
import Modal from '@/components/ui/Modal.vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import StarRating from 'vue-star-rating'
import { RatingChips } from '@/config/variables'
import ChipInput from '@/components/ui/ChipInput.vue'
import IUserData from '@/types/user'
import FormTextInput from '@/components/ui/FormTextInput.vue'
import { currencyFormatBR } from '@/use/numberFormatBR'
import { theme } from '@/config/styles'

/**
 * Component de finalização dos formulário.
 * @prop {String[]} messages - Array de string com as mensagens de finalização.
 * @prop {String} buttonLabel - Label para o botão
 * @prop {Boolean} useRateStar - Boolean para saber se vai usar avaliação
 * com estrela ou sem.
 * @event newRequestClicked - Evento Acionado quando o modal é fechado.
 * @event rateClicked - Evento acionado quando o botão é clicado.
 */
const __default__ = defineComponent({
    props: {
        messages: {
            type: Array as PropType<string[]>,
            default: () => {
                return ['Recebemos sua solicitação!']
            },
        },
        buttonLabel: {
            type: String,
            default: 'Fechar',
        },
        useRateStar: {
            type: Boolean,
            default: false,
        },
        useRatingChips: {
            type: Boolean,
            default: false,
        },
        userData: {
            type: Object as PropType<IUserData>,
            required: false,
        },
    },
    emits: ['newRequestClicked', 'rateClicked'],
    components: {
        ButtonDefault,
        Sucess,
        Modal,
        StarRating,
        ChipInput,
        FormTextInput,
    },
    setup(props, context) {
        const feedbackStar = ref({
            name: '',
            email: '',
            message: '',
            rateStar: 0,
        })
        const ratingChips = RatingChips
        const chipsText = ref([] as string[])
        const inputRating = ref('')
        /**
         * Função invoca o emit para fechar o modal.
         */
        const handleOkButtonClicked = () => {
            context.emit('newRequestClicked')
        }
        /**
         * Função invoca o emit para submeter uma avaliação com estrela.
         * E fechar o modal.
         */
        const handleRateStar = () => {
            let chipText
            let tempMessage = ''
            let newFeedbackStar = { ...feedbackStar.value }
            for (chipText of chipsText.value) {
                tempMessage += chipText + ', '
            }
            if (inputRating.value.length > 0)
            {
                tempMessage += ' inputRating: { '
                tempMessage += inputRating.value + ' }'
            }
            newFeedbackStar.message = tempMessage
            if (newFeedbackStar.rateStar >= 0)
                context.emit('rateClicked', newFeedbackStar)
        }
        const chipClicked = (label: string) => {
            const newChipsText = [...chipsText.value]
            const pos = newChipsText.indexOf(label)
            if (pos == -1) newChipsText.push(label)
            else newChipsText.splice(pos, 1)
            chipsText.value = newChipsText
        }
        return {
            handleOkButtonClicked,
            feedbackStar,
            handleRateStar,
            currencyFormatBR,
            ratingChips,
            chipClicked,
            chipsText,
            inputRating,
            theme
        }
    },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "4e1d30fa": (_ctx.theme.colors.primary.lightest),
  "9dd98fd0": (_ctx.theme.colors.primary.midlight),
  "c1fd55ea": (_ctx.theme.colors.white),
  "fcdcf798": (_ctx.theme.colors.primary.middark),
  "0f834526": (_ctx.theme.colors.secondary.middark)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__